/* tslint:disable */
/* eslint-disable */
/**
 * Roles API
 * API for managing user roles
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RoleMinimalDto } from './RoleMinimalDto';
import {
    RoleMinimalDtoFromJSON,
    RoleMinimalDtoFromJSONTyped,
    RoleMinimalDtoToJSON,
    RoleMinimalDtoToJSONTyped,
} from './RoleMinimalDto';

/**
 * 
 * @export
 * @interface GetCurrentRoleResponse
 */
export interface GetCurrentRoleResponse {
    /**
     * 
     * @type {RoleMinimalDto}
     * @memberof GetCurrentRoleResponse
     */
    currentRole: RoleMinimalDto;
    /**
     * List of all available roles for the user
     * @type {Array<RoleMinimalDto>}
     * @memberof GetCurrentRoleResponse
     */
    roles: Array<RoleMinimalDto>;
}

/**
 * Check if a given object implements the GetCurrentRoleResponse interface.
 */
export function instanceOfGetCurrentRoleResponse(value: object): value is GetCurrentRoleResponse {
    if (!('currentRole' in value) || value['currentRole'] === undefined) return false;
    if (!('roles' in value) || value['roles'] === undefined) return false;
    return true;
}

export function GetCurrentRoleResponseFromJSON(json: any): GetCurrentRoleResponse {
    return GetCurrentRoleResponseFromJSONTyped(json, false);
}

export function GetCurrentRoleResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetCurrentRoleResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'currentRole': RoleMinimalDtoFromJSON(json['currentRole']),
        'roles': ((json['roles'] as Array<any>).map(RoleMinimalDtoFromJSON)),
    };
}

export function GetCurrentRoleResponseToJSON(json: any): GetCurrentRoleResponse {
    return GetCurrentRoleResponseToJSONTyped(json, false);
}

export function GetCurrentRoleResponseToJSONTyped(value?: GetCurrentRoleResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currentRole': RoleMinimalDtoToJSON(value['currentRole']),
        'roles': ((value['roles'] as Array<any>).map(RoleMinimalDtoToJSON)),
    };
}

